import { SET_FAQ } from '../actions'

const initialState = {
    data: []
}

export const faqReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FAQ: {
            return {
                ...state,
                data: action.payload
            }
        }
        default:
            return state
    }
}